module.exports = __webpack_public_path__ + "img/quizz-step-8-3.4d58857d.jpg";